import React, { type Dispatch, type SetStateAction } from 'react';

import {
  AtomicFooterType,
  AtomicHeaderType,
  AtomicItemListType,
  type IScreensComponent,
} from '../../../api';
import {
  HeadlineSmallOneLine,
  HeadlineSmallOneLineWithText,
  HeadlineXsmallOneLine,
} from '../Header';
import {
  Divider,
  GoodsCarousel,
  ProfileInfo,
  ThreeColGoodsList,
  TwoColGoodsList,
  TwoColCardList,
  TwoLineMessage,
  Proxy,
  FilterList,
  Empty,
  NotificationGuide,
  CompanyInfo,
  SearchBar,
  NeonSignBoard,
  Summary,
} from '../ItemList';
import { FooterMore } from '../Footer';

export const HeaderComponent = {
  [AtomicHeaderType.HeadlineSmallOneLine]: HeadlineSmallOneLine,
  [AtomicHeaderType.HeadlineXsmallOneLine]: HeadlineXsmallOneLine,
  [AtomicHeaderType.HeadlineSmallOneLineWithText]: HeadlineSmallOneLineWithText,
};

export const ItemListComponent = {
  [AtomicItemListType.PROFILE_INFO]: ProfileInfo,
  [AtomicItemListType.Divider]: Divider,
  [AtomicItemListType.GoodsCarousel]: GoodsCarousel,
  [AtomicItemListType.FilterList]: FilterList,
  [AtomicItemListType.TwoColGoodsList]: TwoColGoodsList,
  [AtomicItemListType.TwoColCardList]: TwoColCardList,
  [AtomicItemListType.ThreeColGoodsList]: ThreeColGoodsList,
  [AtomicItemListType.TwoLineMessage]: TwoLineMessage,
  [AtomicItemListType.Proxy]: Proxy,
  [AtomicItemListType.Empty]: Empty,
  [AtomicItemListType.NotificationGuide]: NotificationGuide,
  [AtomicItemListType.CompanyInfo]: CompanyInfo,
  [AtomicItemListType.SearchBar]: SearchBar,
  [AtomicItemListType.NeonSignBoard]: NeonSignBoard,
  [AtomicItemListType.Summary]: Summary,
};

export const FooterComponent = {
  [AtomicFooterType.More]: FooterMore,
};

export const createAtomicComponent = (params: {
  component: IScreensComponent;
  index: number;
  likeMap: Record<string, boolean>;
  setLikeMap: Dispatch<SetStateAction<Record<string, boolean>>>;
  scrollToFilterList?: VoidFunction;
}) => {
  const { component, likeMap, setLikeMap, scrollToFilterList } = params;
  const Header = component.type.header
    ? HeaderComponent[component.type.header]
    : null;

  const Footer = component.type.footer
    ? FooterComponent[component.type.footer]
    : null;

  const ItemList = component.type.itemList
    ? ItemListComponent[component.type.itemList]
    : null;

  return (
    <>
      {Header && <Header header={component.entity.header} />}
      {ItemList && component.entity.itemList && (
        <ItemList
          entity={component.entity.itemList}
          body={component.entity.body}
          logging={component.logging}
          scrollToFilterList={
            scrollToFilterList ? scrollToFilterList : () => {}
          }
          likeMap={likeMap}
          setLikeMap={setLikeMap}
        />
      )}
      {Footer && <Footer footer={component.entity.footer} />}
    </>
  );
};
